import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Drawer, Button } from "antd";
import FooterDisplay from "../../components/footer";
import { ROLE_CONFIGS } from "../../common/role_configs";

const SupportLayout = ({ children, userRole = "SO" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const roleConfig = ROLE_CONFIGS[userRole?.toUpperCase()] || ROLE_CONFIGS.SO;
  const allMenuItems = roleConfig.menuItems;
  const primaryMenuItems = allMenuItems.slice(0, 4);
  const moreMenuItems = allMenuItems.slice(4);

  const getActiveSection = () => {
    const path = location.pathname;
    const item = allMenuItems.find((m) => m.to === path);
    return item?.key || "home";
  };

  const handleSectionChange = (section) => {
    const menuItem = allMenuItems.find((item) => item.key === section);
    if (menuItem) {
      navigate(menuItem.to);
      setDrawerOpen(false);
    }
  };

  const footerMenuItems = [
    ...primaryMenuItems,
  ];

  if (moreMenuItems.length > 0) {
    footerMenuItems.push({
      key: "more",
      icon: "ellipsis-horizontal",
      label: "More",
      onClick: () => setDrawerOpen(true),
      isActive: false,
    });
  }

  return (
    <div className="userprofile">
      <div className="profile-content pb-40">
        <div className="gray_bg_profile">
          <div className="profile_to_left">
            <div className=""></div>
          </div>
          <div className="profile_to_right">
            <div className="contain">
              <div className="main_container">{children}</div>
            </div>
          </div>
        </div>
      </div>

      <FooterDisplay
        activeSection={getActiveSection()}
        menuItems={footerMenuItems}
        onSectionChange={handleSectionChange}
      />

      <Drawer
        title="More Menu"
        placement="bottom"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        height="auto"
      >
        <div className="space-y-3">
          {moreMenuItems.map((item) => (
            <Button
              key={item.key}
              block
              size="large"
              onClick={() => handleSectionChange(item.key)}
              type={getActiveSection() === item.key ? "primary" : "default"}
            >
              {item.label}
            </Button>
          ))}
        </div>
      </Drawer>
    </div>
  );
};

export default SupportLayout;
